<mojo-tilebar-item *ngFor="let item of (items$ | async); last as isLast">
  <mojo-overview-item [active]="item.active"
                      [route]="item.route"
                      [showNumber]="item.showNumber"
                      [number]="item.number"
                      [label]="item.label"
                      [backgroundClass]="item.backgroundClass"
                      [allowNavigation]="item.clickEnabled(item)"
                      [queryParams]="item.queryParams"
                      [class.margin]="!isLast"></mojo-overview-item>
</mojo-tilebar-item>
